import script from "./OnlineAppointment.vue?vue&type=script&setup=true&lang=js"
export * from "./OnlineAppointment.vue?vue&type=script&setup=true&lang=js"

import "./OnlineAppointment.vue?vue&type=style&index=0&id=8d34cc62&lang=css"

const __exports__ = script;

export default __exports__